import dateformat from "dateformat";
export default function (value, format = "dd.mm.yyyy") {
  return dateformat(value, format);
}
